// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BlockOutlinedSvg from "@fishx/icons-svg/es/asn/BlockOutlined";
import FishxIcon from '../components/FishxIcon';

var BlockOutlined = function BlockOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BlockOutlinedSvg
  }));
};

BlockOutlined.displayName = 'BlockOutlined';
export default React.forwardRef(BlockOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BlockOutlined.js
// module id = 2075
// module chunks = 0